(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pk-interactions"] && !Shopify.designMode) return;
  try {
    (() => {
 const policy=document.querySelector('.shopify-policy__body');
 if(policy){
  const walker=document.createTreeWalker(policy,NodeFilter.SHOW_TEXT);
  let node;
  while((node=walker.nextNode()))node.nodeValue=node.nodeValue.replace('bel  of e-mail ons dan op info@padelkompas.shop of neem contact met ons op via Jan Vogellaan 6a, 3451 SL Vleuten, Nederland Voor de doeleinden','e-mail ons dan via info@padelkompas.shop. Voor de doeleinden').replace('of neem contact met ons op via Jan Vogellaan 6a, 3451 SL Vleuten, Nederland','');
 }
 document.addEventListener('click', async event => {
  const menu=event.target.closest('[data-pk-menu]');
  if(menu){const nav=document.getElementById('pk-nav');const open=nav.classList.toggle('open');menu.setAttribute('aria-expanded',String(open));}
  const thumb=event.target.closest('[data-pk-image]');
  if(thumb){const image=document.getElementById('pk-main-image');if(image){image.removeAttribute('srcset');image.src=thumb.dataset.pkImage;image.alt=thumb.dataset.alt;}}
 const cookies=event.target.closest('[data-pk-cookies]');
  if(cookies){try{if(!window.privacyBanner?.showPreferences)throw new Error('unavailable');await window.privacyBanner.showPreferences();}catch{const message=document.querySelector('[data-pk-cookie-message]');if(message)message.textContent=document.getElementById('pk-cookie-error').textContent;}}
  const preset=event.target.closest('[data-pk-budget-preset]');
  if(preset){const form=preset.closest('[data-pk-guide]');const input=form?.querySelector('[data-pk-budget]');if(input){input.value=preset.dataset.pkBudgetPreset;form.querySelectorAll('[data-pk-budget-preset]').forEach(button=>button.setAttribute('aria-pressed',String(button===preset)));}}
 });
 document.addEventListener('change',event=>{if(event.target.matches('[data-pk-submit]'))event.target.form.requestSubmit();if(event.target.matches('[data-pk-variant-url]')){const url=new URL(event.target.dataset.pkVariantUrl,location.origin);url.searchParams.set('variant',event.target.value);const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);location.assign(url);}});
 document.addEventListener('submit',event=>{
  const form=event.target.closest('[data-pk-guide]');
  if(!form)return;
  event.preventDefault();
  const data=new FormData(form);
  const level=data.get('level'),style=data.get('style'),shape=data.get('shape'),budget=Number(data.get('budget'))*100;
  const results=document.querySelector('[data-pk-guide-results]');
  const cards=[...results.querySelectorAll('[data-level]')];
  cards.forEach(card=>{card.hidden=true;});
  const eligible=cards.filter(card=>{
   const levelFits=level==='beginner'?card.dataset.level==='beginner':level==='regular'?card.dataset.level!=='advanced':card.dataset.level!=='beginner';
   return levelFits&&Number(card.dataset.price)<=budget;
  });
  eligible.sort((a,b)=>{
   const score=card=>Number(card.dataset.level===level)*4+Number(style!=='any'&&card.dataset.style===style)*5+Number(shape!=='any'&&card.dataset.shape===shape)*3;
   return score(b)-score(a)||Number(a.dataset.price)-Number(b.dataset.price);
  });
  const styleMatches=style==='any'?[]:eligible.filter(card=>card.dataset.style===style);
  const shapeMatches=shape==='any'?[]:eligible.filter(card=>card.dataset.shape===shape);
  const selected=(styleMatches.length?styleMatches:shapeMatches.length?shapeMatches:eligible).slice(0,3);
  selected.forEach(card=>{
   const reasons=[form.dataset.reasonLevel];
   const styleChoice=form.querySelector('[name="style"]:checked');
   const shapeChoice=form.querySelector('[name="shape"]:checked');
   if(style!=='any')reasons.push(card.dataset.style===style?form.dataset.reasonStyle+': '+styleChoice.dataset.label:form.dataset.reasonStyleDifferent);
   if(shape!=='any')reasons.push(card.dataset.shape===shape?form.dataset.reasonShape+': '+shapeChoice.dataset.label:form.dataset.reasonShapeDifferent);
   if(reasons.length===1)reasons.push(form.dataset.reasonCompare);
   card.querySelector('[data-pk-match-reason]').textContent=reasons.join(' · ');
   results.append(card);
   card.hidden=false;
  });
  results.hidden=!selected.length;
  const output=document.querySelector('[data-pk-guide-output]');
  const message=document.querySelector('[data-pk-guide-message]');
  const count=document.querySelector('[data-pk-result-count]');
  output.hidden=false;
  message.textContent=selected.length?form.dataset.found:form.dataset.empty;
  count.textContent=String(selected.length);
  output.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
 });
})();
  } catch(e) { console.error(e); }
})();

})();
